import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class RentalBus extends BaseBus{

    constructor(busObj: RentalBus) {
        super(busObj);

    }
    CID(): any {
        return this.rentalsId;
    }
    setId(id: any) {
        this.rentalsId = id;
    }
    setParentId(id: any) {
        this.bidDetailID = id;
    }
    initialize(data: RentalBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: RentalBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }

    rentalsId :string;
    bidDetailID : string;
    description : string;
    cost : number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    sortOrder  : number;
    public dragging: boolean;
    rentalsMasterId: any;
}
export class RentalDescription {
    rentalsMasterId: string;
    description: string;
    cost: number;
    sequence: null;
    insertDt: Date;
    insertUserId: string;
    updateDt: Date;
    updateUserId: string;
    isActive: null;
    canDelete: boolean
}